import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Field, reduxForm } from "redux-form";
import { bindActionCreators } from "redux";
import moment from "moment";
import toast from "react-hot-toast";
import {
  checkEvent,
  validateEmailForAppUser,
  addAppUser,
  updateCompanybySeocode,
} from "@mainaction";
import {
  renderFieldRadio,
  renderFieldText,
  renderHtmlInputDatePicker,
  validateEmail,
  classNames,
  startsWithcaseIncincitive,
} from "@basecomponent";
import { addVehicle, validateNumberPlate } from "@numberplateaction";
import LocaleStrings from "@language";

const renderFieldCheckbox = (field) => {
  return (
    <div className="flex items-start">
      <div className="flex items-center h-5">
        <input
          className="checkbox-field"
          {...field.input}
          type={field?.type ?? "checkbox"}
        />
      </div>
      <div className="ml-3 text-sm">
        <label
          htmlFor={field?.input?.name ?? ""}
          className="text-sm text-secondary"
        >
          {LocaleStrings.signup_form_label_age}
        </label>
      </div>
    </div>
  );
};

const Signup = (props) => {
  const navigate = useNavigate();
  var { handleSubmit, pristine, invalid, submitting, session, eventData } =
    props;
  var [loading, setLoading] = useState(false);
  //console.log("eventData", eventData);
  const handleSignin = () => {
    navigate("/auth/login");
  };

  useEffect(() => {
    var hostname = window.location.hostname;
    var seocode = hostname.split(".")[0];
    //var seocode = "carlaundry";
    props.checkEvent(session, seocode, (res) => {});
  }, []);

  const onSubmitForm = (values) => {
    // console.log("values :- ", values);
    let emailS = values?.email.trim();
    let email = "";
    let isBadge = false;
    if (startsWithcaseIncincitive(emailS)) {
      isBadge = true;
      if (eventData.emaildomain) {
        email = emailS + "@" + eventData.emaildomain;
      } else {
        email = emailS + "@" + eventData.seocode + ".com";
      }
    } else {
      email = emailS;
    }

    values.email = email;
    values.password = values?.password.trim();
    values.type = "email";
    values.seocode = eventData.seocode;
    // console.log("values", values);
    //debugger;

    if (values?.terms_condition) {
      props.autofill("email", emailS);
      setLoading(true);
      if (isBadge) {
        props.validateNumberPlate(session, emailS.toUpperCase(), (response) => {
          if (response.success === 2) {
            setLoading(false);
            toast.error(LocaleStrings.badge_already_exist);
          } else if (response.success === 1) {
            props.validateEmailForAppUser(session, values, (callback) => {
              if (callback.success == 2) {
                setLoading(false);
                toast.error(callback.message);
              } else if (callback.success == 0) {
                setLoading(false);
                toast.error(LocaleStrings.signup_error_check_terms_conditions);
              } else {
                props.addAppUser(session, values, (res) => {
                  if (res.success == 1 && res.session && res.userid) {
                    let bData = {};
                    bData.hruserid = res.userid;
                    bData.isbadge = 1;
                    bData.numberplate = emailS.toUpperCase();
                    bData.programid = null;

                    props.addVehicle(
                      res.session,
                      bData,
                      eventData.useridfk,
                      null,
                      (feedback) => {
                        //console.log("feedback", feedback);

                        if (feedback.success === 1) {
                          props.updateCompanybySeocode(
                            res.session,
                            values.seocode,
                            (callback) => {
                              if (callback.success == 1) {
                                setLoading(false);
                                navigate("/dashboard");
                              } else {
                                setLoading(false);
                                toast.error(
                                  LocaleStrings.signup_error_registration_failed
                                );
                              }
                            }
                          );
                        } else {
                          setLoading(false);
                          toast.error(LocaleStrings.common_fail_message);
                        }
                      }
                    );
                  } else {
                    setLoading(false);
                    toast.error(LocaleStrings.signup_error_registration_failed);
                  }
                });
              }
            });
          } else {
            setLoading(false);
            toast.error(LocaleStrings.common_fail_message);
          }
        });
      } else {
        props.validateEmailForAppUser(session, values, (callback) => {
          if (callback.success == 2) {
            setLoading(false);
            toast.error(callback.message);
          } else if (callback.success == 0) {
            setLoading(false);
            toast.error(LocaleStrings.signup_error_check_terms_conditions);
          } else {
            props.addAppUser(session, values, (res) => {
              setLoading(false);
              if (res.success == 1 && res.session) {
                props.updateCompanybySeocode(
                  res.session,
                  values.seocode,
                  (callback) => {
                    if (callback.success == 1) {
                      navigate("/dashboard");
                    } else {
                      toast.error(
                        LocaleStrings.signup_error_registration_failed
                      );
                    }
                  }
                );
              } else {
                toast.error(LocaleStrings.signup_error_registration_failed);
              }
            });
          }
        });
      }
    } else {
      setLoading(false);
      toast.error(LocaleStrings.signup_error_check_terms_conditions);
    }
  };

  return (
    <>
      <div className="min-h-full">
        <div className="flex items-center justify-center mt-6 text-2xl text-primary">
          <h2 className="mt-6 text-3xl font-extrabold text-primary text-center">
            {LocaleStrings.signup_title_signup}
          </h2>
        </div>
        <div className="flex items-center justify-center mt-6 text-2xl text-primary text-center">
          {LocaleStrings.signup_subtitle}
        </div>
        <div className="flex  items-center justify-center py-12 px-4 sm:px-6 lg:flex-none lg:px-20 xl:px-24">
          <div className="mx-auto w-full max-w-sm lg:w-96">
            <div className="mt-8 border rounded-md p-7 shadow-md">
              <form onSubmit={handleSubmit(onSubmitForm)} className="space-y-6">
                <Field
                  name="name"
                  label={LocaleStrings.signup_form_label_fullname}
                  type="text"
                  component={renderFieldText}
                  mandatory="true"
                  maxlength={100}
                />
                <Field
                  name="email"
                  label={LocaleStrings.signup_form_label_email}
                  type="text"
                  component={renderFieldText}
                  mandatory="true"
                  maxlength={100}
                />
                <Field
                  name="password"
                  label={LocaleStrings.signup_form_label_password}
                  type="password"
                  component={renderFieldText}
                  mandatory="true"
                  maxlength={100}
                />
                <Field
                  name="confirm_password"
                  label={LocaleStrings.signup_form_label_confpassword}
                  type="password"
                  component={renderFieldText}
                  mandatory="true"
                  maxlength={100}
                />
                <Field
                  name="terms_condition"
                  type="checkbox"
                  component={renderFieldCheckbox}
                />

                <div>
                  <button
                    type="submit"
                    className="w-full theme-button-md"
                    disabled={pristine || invalid || submitting || loading}
                  >
                    <svg
                      className={classNames(
                        loading ? "" : "hidden",
                        "cust-btn-spinner"
                      )}
                      viewBox="0 0 1024 1024"
                      focusable="false"
                      data-icon="btnloading"
                      width="1em"
                      height="1em"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path d="M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z"></path>
                    </svg>
                    {LocaleStrings.button_signup}
                  </button>
                </div>
              </form>
            </div>

            <div className="mt-8">
              <div className="text-center text-sm">
                {LocaleStrings.signup_agree_text}{" "}
                <a
                  className="text-theme cursor-pointer hover:underline"
                  target="_blank"
                  href="https://carwashadmin.tikwash.com/settings.php?t=terms"
                >
                  {LocaleStrings.signup_terms_text}
                </a>{" "}
                {LocaleStrings.signup_and}{" "}
                <a
                  className="text-theme cursor-pointer hover:underline"
                  target="_blank"
                  href="https://carwashadmin.tikwash.com/settings.php?t=privacy"
                >
                  {LocaleStrings.signup_privacy}
                </a>
              </div>
            </div>

            <div className="mt-8">
              <div className="text-center text-sm">
                <span className="px-2 bg-white text-secondary">
                  {LocaleStrings.signup_text_already_an_account}
                </span>
                <span
                  onClick={handleSignin}
                  className="bg-white text-theme cursor-pointer hover:underline"
                >
                  {LocaleStrings.button_login}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const validate = (values) => {
  var errors = {};
  var usertype = values["usertype"];
  var fullname = values["fullname"];
  var email = values["email"];
  var password = values["password"];
  var confirm_password = values["confirm_password"];

  if (!fullname || fullname.trim() === "") {
    errors["fullname"] = LocaleStrings.required;
  }
  if (!email || email.trim() === "") {
    errors["email"] = LocaleStrings.required;
  } else if (!validateEmail(email) && !startsWithcaseIncincitive(email)) {
    errors["email"] = LocaleStrings.invalid_email;
  }
  if (!password || password.trim() === "") {
    errors["password"] = LocaleStrings.required;
  } else if (password && password?.length < 6) {
    errors["password"] = LocaleStrings.signup_form_validation_min_password;
  }
  if (!confirm_password || confirm_password.trim() === "") {
    errors["confirm_password"] = LocaleStrings.required;
  } else if (confirm_password != password) {
    errors["confirm_password"] =
      LocaleStrings.signup_form_validation_conf_password;
  }
  return errors;
};

const mapStateToProps = (state) => {
  var init = { usertype: "user" };
  return {
    session: state.session,
    initialValues: init,
    eventData: state.eventData,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      validateEmailForAppUser,
      addAppUser,
      updateCompanybySeocode,
      addVehicle,
      validateNumberPlate,
      checkEvent,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  reduxForm({
    validate,
    form: "SignupForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(Signup)
);
